import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { createSelector } from 'reselect';
import { toggleFbCreateCatalogModal } from '../../../../slices/modals/reducer';
import { createFacebookCatalog } from '../../../../slices/publish/facebook/thunk';

function CreateCatalogModal() {
  const dispatch = useDispatch();

  const selectState = createSelector(state => state, state => ({
    modalState: state.Modal.fbCreateCatalogModal
  }));
  const {modalState} = useSelector(selectState);
  const [catalogName, setCatalogName] = useState('');
  
  function handleChange(e) {
    setCatalogName(e.target.value);
  }

  function closeModal() {
    dispatch(toggleFbCreateCatalogModal());
  }

  async function handleCreate() {
    dispatch(createFacebookCatalog(catalogName));
    dispatch(toggleFbCreateCatalogModal());
  }

  return (
    <Modal isOpen={modalState} toggle={closeModal} centered size='sm'>
      <ModalHeader className='p-3' toggle={closeModal}>
        Create Catalog
      </ModalHeader>
      <ModalBody>
        <Label htmlFor='catalogName'>Name</Label>
        <Input type='text' name='catalogName' id='catalogName' value={catalogName} onChange={handleChange} />
      </ModalBody>
      <ModalFooter>
        <button className='btn btn-light' onClick={closeModal}>Close</button>
        <button className='btn btn-success' onClick={handleCreate}>
          Create
        </button>
      </ModalFooter>
    </Modal>
  )
}

export default CreateCatalogModal
